import pagerduty from 'src/lib/api/pagerduty';

import { createPagerDutyReferenceSelect } from './createPagerDutyReferenceSelect';

export { default as GenericAsyncSelect } from './GenericAsyncSelect';
export { default as IncidentsSelect } from './IncidentsSelect';
export { default as JiraUserSelect } from './JiraUserSelect';
export { default as PdIncidentWorkflowTriggerSelect } from './PdIncidentWorkflowTriggerSelect';
export { default as ProjectsSelect } from './ProjectsSelect';

export const ServicesSelect = createPagerDutyReferenceSelect(
  filter => pagerduty.getPagerDutyServices(filter),
  { placeholder: 'Select PagerDuty service...' }
);

export const PdUsersSelect = createPagerDutyReferenceSelect(
  filter => pagerduty.getUsers(filter),
  { placeholder: 'Select PagerDuty user...', hasIcons: true }
);

export const PdEscalationPolicySelect = createPagerDutyReferenceSelect(
  filter => pagerduty.getEscalationPolicies(filter),
  { placeholder: 'Select Escalation policy...' }
);

export const PdPrioritySelect = createPagerDutyReferenceSelect(
  filter => pagerduty.getPriorities().then(result => [...result.priorities, {
    id: null,
    type: `priority_reference`,
    summary: 'No Priority',
    self: 'https://api.pd-staging.com/priorities/null',
    html_url: null,
    account_id: null,
    color: null,
    created_at: null,
    description: 'No Priority',
    name: 'No Priority',
    order: 0,
    schema_version: 0,
    updated_at: null
  }]),
  { placeholder: 'Select incident priority...', hasIcons: true }
);
